import { Injectable } from '@angular/core';
import { StoreService } from './store.service';
import { Test } from '../_model/test';

@Injectable()
export class HelperService {

    constructor(private storeService: StoreService) {
    }

    setClosestServer() {
        const servers = this.storeService.servers;
        const isp = this.storeService.isp;

        const countArray = [];
        for (let i = 0; i < servers.length; ++i) {
            const object = servers[i];
            const distance = this.distanceInKmBetweenEarthCoordinates(object.latitude, object.longitude, isp.latitude, isp.longitude);

            countArray.push({
                server: object,
                distance: distance,
            });
        }

        const finalArray = countArray.sort(this.dynamicSort('distance'));
        this.storeService.testServer = finalArray[0].server;
    }

    degreesToRadians(degrees: number) {
        return degrees * Math.PI / 180;
    }

    distanceInKmBetweenEarthCoordinates(lat1: number, lon1: number, lat2: number, lon2: number) {
        const earthRadiusKm = 6371;

        const dLat = this.degreesToRadians(lat2 - lat1);
        const dLon = this.degreesToRadians(lon2 - lon1);

        lat1 = this.degreesToRadians(lat1);
        lat2 = this.degreesToRadians(lat2);

        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        return earthRadiusKm * c;
    }

    dynamicSort(property: any) {
        let sortOrder = 1;
        if (property[0] === '-') {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a: any, b: any) {
            const result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
            return result * sortOrder;
        };
    }

    processIsp(object: any) {
        this.storeService.isp.as = object.as;
        this.storeService.isp.city = object.city;
        this.storeService.isp.country = object.country;
        this.storeService.isp.countryCode = object.countryCode;
        this.storeService.isp.ipType = object.ipType;
        this.storeService.isp.isp = object.isp;
        this.storeService.isp.ip = object.ip;
        this.storeService.isp.latitude = object.lat;
        this.storeService.isp.longitude = object.lon;
        this.storeService.isp.org = object.org;
        this.storeService.isp.region = object.region;
        this.storeService.isp.regionName = object.regionName;
        this.storeService.isp.timezone = object.timezone;
        this.storeService.isp.zip = object.zip;

        this.storeService.test.isp = this.storeService.isp;
        // this.storeService.test.ip = object.query;
        this.storeService.ispName = object.isp;
    }

    getTestLocalStorage(): Test[] {
        const localStorageItem = JSON.parse(localStorage.getItem('tests'));
        return localStorageItem == null ? [] : localStorageItem.tests;
    }

    setTestLocalStorage(tests: Test[]) {
        localStorage.setItem('tests', JSON.stringify({tests: tests}));
    }

    isMobileOperatingSystem(): boolean {
        const userAgent = navigator['userAgent'] || navigator['vendor'] || window['opera'];
        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return true;
        }
        if (/android/i.test(userAgent)) {
            return true;
        }
        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window['MSStream']) {
            return true;
        }

        return false;
    }

    getMobileOperatingSystem(): string {
        const userAgent = navigator['userAgent'] || navigator['vendor'] || window['opera'];

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return 'Windows Phone';
        }

        if (/android/i.test(userAgent)) {
            return 'Android';
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window['MSStream']) {
            return 'iOS';
        }

        return 'unknown';
    }
}
